import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AuthManagementState } from './types';
import { LoginFormType } from './containers/NativeLogin/types';

export const initialState: AuthManagementState = {
  loading: false,
  error: '',
  isAuthenticated: false,
  challengeUser: null
};

const authSlice = createSlice({
  name: 'authManagement',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<LoginFormType>) => {
      state.loading = true;
      state.error = '';
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.error = '';
    },
    loginFailed: (state, action) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.error = action.payload;
    },
    loginChallengeRequired: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.challengeUser = action.payload;
    },
    setNewPassword: (state, action: PayloadAction<{ newPassword: string }>) => {
      state.loading = true;
      state.error = '';
    },
    setNewPasswordSuccess: state => {
      state.loading = false;
      state.challengeUser = null;
      state.isAuthenticated = true;
    },
    setNewPasswordFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  login,
  loginSuccess,
  loginFailed,
  loginChallengeRequired,
  setNewPassword,
  setNewPasswordSuccess,
  setNewPasswordFailed
} = authSlice.actions;

export default authSlice.reducer;
